import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/dist/ScrollSmoother";

import "./styles.scss";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

class ExoviaSmoothScrolling {
  constructor() {
    this.gsapSmoothScroller = ScrollSmoother.create({
      smooth: 1.25,
      effects: true,
    });
    this.callback = () => {};
    this.addEvents();
  }
  addEvents() {
    window.addEventListener("resize", () => {
      this.killEffects();
      this.callback();
    });
  }
  killEffects = () => {
    this.gsapSmoothScroller.effects().forEach((fx) => fx.kill());
  };
  setEffects = (cb) => {
    this.callback = cb;
    cb();
  };
  pause = () => {
    this.gsapSmoothScroller.paused(true);
  };
  unpause = () => {
    this.gsapSmoothScroller.paused(false);
  };
  refresh = () => {
    this.gsapSmoothScroller.refresh();
  };
  destroy = () => {
    this.killEffects();
    this.gsapSmoothScroller.kill();
  };
}

export { ExoviaSmoothScrolling };
